import Modal from 'react-modal';
import React from 'react';
import modal from '../../../../definitions/Modal';

const contactListModal = modal({
  content: { width: '500px', padding: '40px 40px 30px 40px' },
});

const ModalWrapper = ({ modal, closeModal }) => {
  return (
    <Modal
      isOpen={modal != null}
      shouldReturnFocusAfterClose
      shouldFocusAfterRender
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      style={contactListModal}
    >
      {modal &&
        React.createElement(modal.content, { ...modal.props, closeModal })}
    </Modal>
  );
};

export default ModalWrapper;
